import React from 'react'
import PropTypes from 'prop-types'
import {
  Text,
  Spacer,
  Box,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import CopyButton from '../../components/CopyButton'

const BankAccountDetailsModal = ({
  isOpen,
  onClose,
  supplierName,
  accountName,
  bankAccountBranchCode,
  bankAccountNumber,
}) => {
  const {t} = useTranslation('payerStatements')

  const details = [
    {
      label: t('bankAccountDetails.modal.account.accountName'),
      tooltip: t('bankAccountDetails.modal.account.tooltip.accountName'),
      value: accountName,
      testId: 'account-name',
    },
    {
      label: t('bankAccountDetails.modal.account.bankAccountBranchCode'),
      tooltip: t(
        'bankAccountDetails.modal.account.tooltip.bankAccountBranchCode',
      ),
      value: bankAccountBranchCode,
      testId: 'bank-account-branch-code',
    },
    {
      label: t('bankAccountDetails.modal.account.bankAccountNumber'),
      tooltip: t('bankAccountDetails.modal.account.tooltip.bankAccountNumber'),
      value: bankAccountNumber,
      testId: 'bank-account-number',
    },
  ]

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('bankAccountDetails.modal.header')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box
            borderWidth={1}
            borderRadius={4}
            borderColor="mld.neutral.500"
            p={4}
            mb={4}
          >
            <Text
              textStyle="body-small"
              textTransform="uppercase"
              borderBottomWidth={1}
              pb={2}
              mb={2}
            >
              {t('bankAccountDetails.modal.account.header')}
            </Text>
            {details.map(({label, tooltip, value, testId}) => (
              <Flex alignItems="center" key={testId}>
                <Box>
                  <Text textStyle="body-copy" textTransform="uppercase">
                    {label}
                  </Text>
                </Box>
                <Spacer />
                <Box pr={4}>
                  <Text textStyle="body-small" data-testid={testId}>
                    {value}
                  </Text>
                </Box>
                <CopyButton
                  color="mld.neutral.700"
                  label={tooltip}
                  size="sm"
                  content={bankAccountBranchCode}
                />
              </Flex>
            ))}
          </Box>
          <Text textStyle="body-copy" mb={4}>
            {t('bankAccountDetails.modal.contact', {supplierName})}
          </Text>
          <Button onClick={onClose} variant="secondary" mb={4}>
            {t('bankAccountDetails.modal.closeButton')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

BankAccountDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  supplierName: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
  bankAccountBranchCode: PropTypes.string.isRequired,
  bankAccountNumber: PropTypes.string.isRequired,
}

export default BankAccountDetailsModal
